import axios from "axios";

// En preview/producción el ingress enruta /api al backend en el mismo dominio,
// así que usar same-origin evita problemas de CORS entre www y apex.
// En desarrollo local (localhost:3000) se usa REACT_APP_BACKEND_URL.
const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const API = isLocal
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : `${window.location.origin}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function waLink(number, message) {
  return `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
}

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
